<div
    class="t-circle"
    [style.left.%]="left"
></div>
